export enum OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings {
  CARGO_RAILY = "CARGO_RAILY",
  TAXI_RAILY = "TAXI_RAILY",
  RAILY_TAXI = "RAILY_TAXI",
}

export type OrderFinishedCargoOrdersUnbilledListClient = {
  name: string;
};

export type OrderFinishedCargoOrdersUnbilledListItem = {
  uuid: string;
  startTime: Date;
  humanId: number;
  isCancelled: boolean;
  rideAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  client: OrderFinishedCargoOrdersUnbilledListClient;
  taxiCorporations: string[];
  drivers: string[];
  externalId: string | null;
  lackingRailyBillings: OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings[];
};

export type OrderFinishedCargoOrdersUnbilledList = {
  data: OrderFinishedCargoOrdersUnbilledListItem[];
  totalCount: number;
};

export default OrderFinishedCargoOrdersUnbilledList;
